const INITIAL_STate = {
  langValue: "",
};

const changeLangRed = (state = INITIAL_STate, action) => {
  switch (action.type) {
    case "CHANGE_LANG":
      return {
        langValue: action.payload,
      };
    default:
      return state;
  }
};

export { changeLangRed };
